import * as yup from 'yup'
import { useMemo } from 'react'
import { toast } from 'react-toastify'
import { Add } from '@mui/icons-material'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { Box, CircularProgress, Typography } from '@mui/material'
import { Form } from '../Form/Form'
import { Input } from '../Form/Input'
import { Button } from '../Form/Button'
import { useContract } from '~/contexts'
import { RegisteredAnnotation } from './components'
import { ContractModel, useContractAddObservationMutation } from '~/graphql/types'
import { usePermission } from '~/hooks'

export type AnnotationForm = {
  annotation: string
}

const schema = yup.object().shape({
  annotation: yup.string().required('Campo obrigatório')
})

export type AnnotationsProps = {
  contract: ContractModel
  customUpdateContract?: Function
}
export const AnnotationsContract: React.FC<AnnotationsProps> = ({ contract, customUpdateContract }) => {
  const { notes } = contract
  const { setContract } = useContract()
  const [addObservationToContract, { loading }] = useContractAddObservationMutation()

  const canAddAnnotations = usePermission(['contractNotes.updated'])

  const renderedAnnotations = useMemo(() => {
    return notes?.map((item: any, index: any) => (
      <RegisteredAnnotation
        key={`annotation-${index}`}
        annotation={item.text}
        createdAt={item.createdAt}
        analystName={item.analystName}
      />
    ))
  }, [notes])

  const methods = useForm<AnnotationForm>({
    resolver: yupResolver(schema)
  })

  const onSubmit = async (formData: AnnotationForm) => {
    try {
      const { data: updateContract } = await addObservationToContract({
        variables: {
          params: {
            _id: contract._id,
            text: formData.annotation
          }
        }
      })

      methods.reset()

      if (customUpdateContract) {
        updateContract && customUpdateContract(updateContract.contractAddObservation as ContractModel)
        return
      }

      updateContract && setContract(updateContract.contractAddObservation as ContractModel)
    } catch (err) {
      toast.error('Houve um problema ao adicionar observação')
    }
  }

  return (
    <FormProvider {...methods}>
      <Form key='annotations'>
        <Box flexDirection='column' display='flex' gap={3}>
          <Typography variant='h3'>Observações</Typography>

          {renderedAnnotations}

          <Input
            multiline
            minRows={5}
            name='annotation'
            disabled={loading || !canAddAnnotations}
            placeholder='Escreva aqui suas observações'
          />

          <Button
            color='secondary'
            style={{ alignSelf: 'start' }}
            disabled={loading || !canAddAnnotations}
            onClick={methods.handleSubmit(onSubmit)}
            startIcon={loading ? <CircularProgress color='inherit' size={24} /> : <Add />}
          >
            Registrar observação
          </Button>
        </Box>
      </Form>
    </FormProvider>
  )
}
